module.exports = __webpack_public_path__ + "static/media/portfolio1 (8).e3ad8782.jpeg";